export default __webpack_public_path__ + "static/media/manage_auto-driver_icon.590535a0.svg";